import { render } from "./EditBuyerGroup.vue?vue&type=template&id=8270ea1c"
import script from "./EditBuyerGroup.vue?vue&type=script&lang=js"
export * from "./EditBuyerGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/EditBuyerGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8270ea1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8270ea1c', __exports__)) {
    api.reload('8270ea1c', __exports__)
  }
  
  module.hot.accept("./EditBuyerGroup.vue?vue&type=template&id=8270ea1c", () => {
    api.rerender('8270ea1c', render)
  })

}


export default __exports__